// Сборка выбирается переменной REACT_APP_EDITION при `npm run build`.
// Webpack подставляет значение и вырезает ветку другой сборки вместе со всеми
// её импортами: код основного сайта не попадает в сборку «только проверки»
// (src/editions/checks) и наоборот. Поэтому здесь require, а не import.
if (process.env.REACT_APP_EDITION === 'checks') {
  require('./editions/checks/entry');
} else {
  require('./mainEntry');
}

export {};
